import React, { PureComponent, Fragment } from 'react';
import { InfoWindow } from 'react-google-maps';
import styled from 'styled-components';

import pxInRem from 'shared/helpers/styled-components/remHelper';
import mediaQueries from 'shared/helpers/styled-components/mediaQueries';
import Loader from '../Loader';

const Wrapper = styled.div`
  position: relative;
  display: flex;
  min-height: 200px;
  min-width: 200px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: ${pxInRem(13)};
  line-height: ${pxInRem(15.5)};
  padding: 0 var(--spacing-xl) var(--spacing-xl) var(--spacing-s);
  text-align: center;
  ${mediaQueries.toPhablet`
    max-width: calc(100vw - 133px); // 15px + 38px (InfoWindow margins) + 2 * 40px (wanted margin around InfoWindow)
  `};
`;

const Header = styled.header`
  margin: 8px 0;
`;

const Name = styled.h2`
  font-size: ${pxInRem(13)};
  margin: 0;
`;

const Type = styled.h3`
  font-size: ${pxInRem(13)};
  margin: 0;
`;

const ContentSection = styled.section`
  color: var(--text-light);
  margin: 8px 0;

  a {
    text-decoration: underline;
  }
`;

const CTASection = styled.nav`
  margin-top: 8px;
`;

export default class MapInfoWindow extends PureComponent {
  static children = {
    Header,
    Name,
    Type,
    ContentSection,
    CTASection
  };

  render() {
    const {
      onCloseClick: handleCloseClick,
      isLoading,
      children,
      ...props
    } = this.props;

    return (
      <InfoWindow onCloseClick={handleCloseClick}>
        <Wrapper {...props}>
          {isLoading ? <Loader /> : <Fragment>{children}</Fragment>}
        </Wrapper>
      </InfoWindow>
    );
  }
}
